
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>회원 관리 - 쿠폰 현황</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminCouponManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
            <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
          </div>

          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_coupon,
  delete_coupon
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminCustomerManagement',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `
        /AdminCouponManagementAdd?coupon_ID=${this.tabulator.getSelectedData()[0].coupon_ID}
        `
      }
    },
    delete_row: function () {
      let temp_delete_array = []
      this.tabulator.getSelectedData().forEach((element) => {
        temp_delete_array.push(element.coupon_ID)
      })
      delete_coupon(temp_delete_array).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.')
        } else {
          alert('삭제가 완료 되었습니다.')
          window.location.reload()
        }
      })
    }
  },
  mounted () {
    get_coupon().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        pagination: 'local',
        paginationSize: 10,
        paginationSizeSelector: [5, 10, 20, 50],
        columns: [
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'ID', field: 'coupon_ID', headerSort: false},
          {title: '고객명', field: 'customer_name', headerSort: false},
          {title: '고객전화번호', field: 'customer_phone_number', headerSort: false},
          {title: '쿠폰이름', field: 'coupon_name', headerSort: false},
          {title: '쿠폰타입', field: 'coupon_type', headerSort: false},
          {title: '할인타입', field: 'coupon_discount_type', headerSort: false},
          {
            title: '할인값',
            field: 'coupon_discount_value',
            headerSort: false,
            hozAlign: 'right',
            formatter: function (cell) {
              const value = parseInt(cell.getValue(), 10)
              return isNaN(value) ? '' : value.toLocaleString()
            }
          },
          {
            title: '최소주문금액',
            field: 'coupon_min_order_amount',
            headerSort: false,
            hozAlign: 'right',
            formatter: function (cell) {
              const value = parseInt(cell.getValue(), 10)
              return isNaN(value) ? '' : value.toLocaleString()
            }
          },
          {title: '쿠폰 사용 시작일', field: 'coupon_valid_from', headerSort: false},
          {title: '쿠폰 사용 종료일', field: 'coupon_valid_until', headerSort: false},
          {title: '발급일자', field: 'coupon_issued_at', headerSort: false},
          {title: '사용여부', field: 'coupon_is_used', headerSort: false},
          {title: '사용일자', field: 'coupon_used_at', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CustomerManagement/AdminCouponManagement.vue